module.exports = __webpack_public_path__ + "static/media/Apple iPhone 8 Plus Silver.73b4191a.png";